import React from 'react';
import { Alert } from 'antd';

function ResultMessage({confirmMessage, confirmStatus}) {
    return (
        <Alert
        message={confirmMessage ? confirmMessage : <>
        پروفایل شما توسط مدیریت تایید نشده است!
        لطفا اطلاعات خود را بازبینی و مجددا ارسال کنید.
        </>}
        type={confirmStatus === "SUCCESS" ? "success" : "error"}
        banner
        style={{ width: "100%", marginBottom: "30px" }}
      />
    );
}

export default ResultMessage;